import React, { Component, useState, useEffect, createRef, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Select from "react-select";
import ReactToPrint from "react-to-print";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";
import { Card, Table, Tabs, Row, Col, Input, Button, DatePicker, Space } from "antd";
import { CSVLink } from "react-csv";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import _ from "lodash";
import { faFileDownload, faPrint, faUserCircle } from "@fortawesome/free-solid-svg-icons";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function ClientReports(props) {
  const [fullClientsList, setFullClientsList] = useState([]);
  const [filteredFullClientsList, setFilteredFullClientsList] = useState([]);
  const [fullClientsListSearchTerm, setFullClientsListSearchTerm] = useState("");
  const [table1PageSize, setTable1PageSize] = useState(25);

  const [fullClientContactsList, setFullClientContactsList] = useState([]);
  const [filteredFullClientContactsList, setFilteredFullClientContactsList] = useState([]);
  const [fullClientContactsListSearchTerm, setFullClientContactsListSearchTerm] = useState("");

  const [noShowStartDates, setNoShowStartDates] = useState([dayjs().subtract(1, "year").startOf("year"), dayjs().subtract(1, "year").endOf("year")]);
  const [noShowEndDates, setNoShowEndDates] = useState([dayjs().startOf("year"), dayjs().endOf("year")]);
  const [noShowJob, setNoShowJob] = useState(null);
  const [noShowClients, setNoShowClients] = useState([]);

  const [items, setItems] = useState([]);
  const [clientCategories, setClientCategories] = useState([]);

  const [clientGrowthDates, setClientGrowthDates] = useState([dayjs().subtract(1, "year").startOf("year"), dayjs()]);
  const [clientGrowthData, setClientGrowthData] = useState([]);
  const [clientGrowthChartData, setClientGrowthChartData] = useState({});
  const [clientGrowthCategories, setClientGrowthCategories] = useState(null);

  const [mailingLabelType, setMailingLabelType] = useState(null);
  const [mailingLabelClients, setMailingLabelClients] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const rowSelection = {
    selectedRowKeys,
    onChange: (new_keys) => {
      setSelectedRowKeys(new_keys);
      setMailingLabelClients(
        fullClientsList
          .filter((f) => new_keys.includes(f.key))
          .map((f) => {
            return { name: f.name, line_1: f.address_line_1 + " " + f.address_line_2, line_2: f.city + ",  " + f.state + " " + f.zip };
          }),
      );
    },
  };
  const printTarget = createRef();
  const printableRef1 = useRef();
  const printableRef2 = useRef();
  const printableRef3 = useRef();

  const GetAllClients = async () => {
    let response = await props.AxiosRequest("/api/clients/reporting/get/all", { include_deleted: true });
    setFullClientsList(
      response.data.clients.map((m) => {
        return { ...m, key: m.id };
      }),
    );
  };
  const GetAllClientContacts = async () => {
    let response = await props.AxiosRequest("/api/client-contacts/reporting/get/all", { include_deleted: false });
    setFullClientContactsList(
      response.data.clients.map((m) => {
        return { ...m, key: m.id };
      }),
    );
  };
  const GetItems = async () => {
    let response = await props.AxiosRequest("/api/items/get");
    setItems(
      response.data.items.map((m) => {
        return { ...m, value: m.id, label: m.name };
      }),
    );
  };
  const GetClientCategories = async () => {
    let response = await props.AxiosRequest("/api/client-categories/get");
    setClientCategories(
      response.data.client_categories.map((m) => {
        return { ...m, value: m.id, label: m.name };
      }),
    );
  };
  const GetNoShows = async () => {
    if (!noShowStartDates || !noShowEndDates || !noShowJob) return props.MakeNotification("warning", "Please select a job item and dates.");
    let response = await props.AxiosRequest("/api/clients/reporting/no-show", {
      job_item: noShowJob.id,
      exists_start: dayjs(noShowStartDates[0]).startOf("day").format("YYYY-MM-DD HH:mm:ss"),
      exists_end: dayjs(noShowStartDates[1]).endOf("day").format("YYYY-MM-DD HH:mm:ss"),
      no_exists_start: dayjs(noShowEndDates[0]).startOf("day").format("YYYY-MM-DD HH:mm:ss"),
      no_exists_end: dayjs(noShowEndDates[1]).endOf("day").format("YYYY-MM-DD HH:mm:ss"),
    });
    setNoShowClients(
      response.data.data.map((m) => {
        return { ...m, key: m.id };
      }),
    );
  };
  const GetClientGrowth = async () => {
    if (!clientGrowthDates) return props.MakeNotification("warning", "Please select a date range.");
    let response = await props.AxiosRequest("/api/clients/reporting/client-growth", {
      client_categories: clientGrowthCategories,
      start: dayjs(clientGrowthDates[0]).startOf("day").format("YYYY-MM-DD HH:mm:ss"),
      end: dayjs(clientGrowthDates[1]).endOf("day").format("YYYY-MM-DD HH:mm:ss"),
    });
    setClientGrowthData(response.data.data);
    let chart_data = await MakeChartData(response.data.data);
    setClientGrowthChartData(chart_data);
  };
  const MakeChartData = async (data) => {
    let labels = [];
    let chart_data_points = [];
    let start_date = clientGrowthDates[0];
    while (start_date.isBefore(clientGrowthDates[1].add(1, "month"))) {
      labels.push(start_date.format("M/YYYY"));
      let filtered_data = data.filter((f) => dayjs(f.created_at).month() === start_date.month() && dayjs(f.created_at).year() === start_date.year());
      chart_data_points.push(filtered_data.length);
      start_date = start_date.add(1, "month");
    }

    let chart_data = {
      labels,
      datasets: [
        {
          label: "Clients Added",
          data: chart_data_points,
          backgroundColor: "rgba(38, 81, 145, 0.5)",
        },
      ],
    };
    return chart_data;
  };
  const FilterFullClientsList = async () => {
    if (fullClientsListSearchTerm?.length === 0) return setFilteredFullClientsList(fullClientsList);
    let filtered_list = fullClientsList.filter((f) =>
      _.toLower(f.name).indexOf(_.toLower(fullClientsListSearchTerm)) > -1 ||
      _.toLower(f.address_line_1).indexOf(_.toLower(fullClientsListSearchTerm)) > -1 ||
      _.toLower(f.address_line_2).indexOf(_.toLower(fullClientsListSearchTerm)) > -1 ||
      _.toLower(f.city).indexOf(_.toLower(fullClientsListSearchTerm)) > -1 ||
      _.toLower(f.state).indexOf(_.toLower(fullClientsListSearchTerm)) > -1 ||
      _.toLower(f.zip).indexOf(_.toLower(fullClientsListSearchTerm)) > -1 ||
      _.toLower(f.client_category_name).indexOf(_.toLower(fullClientsListSearchTerm)) > -1
        ? true
        : false,
    );
    setFilteredFullClientsList(filtered_list);
  };

  const FilterFullClientContactsList = async () => {
    if (fullClientContactsListSearchTerm?.length === 0) return setFilteredFullClientContactsList(fullClientContactsList);
    let filtered_list = fullClientContactsList.filter((f) =>
      _.toLower(f.name).indexOf(_.toLower(fullClientContactsListSearchTerm)) > -1 ||
      _.toLower(f.address_line_1).indexOf(_.toLower(fullClientContactsListSearchTerm)) > -1 ||
      _.toLower(f.address_line_2).indexOf(_.toLower(fullClientContactsListSearchTerm)) > -1 ||
      _.toLower(f.city).indexOf(_.toLower(fullClientContactsListSearchTerm)) > -1 ||
      _.toLower(f.state).indexOf(_.toLower(fullClientContactsListSearchTerm)) > -1 ||
      _.toLower(f.zip).indexOf(_.toLower(fullClientContactsListSearchTerm)) > -1 ||
      _.toLower(f.client_category_name).indexOf(_.toLower(fullClientContactsListSearchTerm)) > -1
        ? true
        : false,
    );
    setFilteredFullClientContactsList(filtered_list);
  };

  useEffect(() => {
    GetAllClients();
    GetAllClientContacts();
    GetItems();
    GetClientCategories();
  }, []);

  useEffect(() => {
    FilterFullClientsList();
  }, [fullClientsList, fullClientsListSearchTerm]);
  useEffect(() => {
    FilterFullClientContactsList();
  }, [fullClientContactsList, fullClientContactsListSearchTerm]);

  const full_client_list_columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1),
    },
    {
      title: "Address Line 1",
      dataIndex: "address_line_1",
      key: "address_line_1",
      sorter: (a, b) => (a.address_line_1.toUpperCase() > b.address_line_1.toUpperCase() ? 1 : -1),
    },
    {
      title: "Address Line 2",
      dataIndex: "address_line_2",
      key: "address_line_2",
      sorter: (a, b) => (a.address_line_2.toUpperCase() > b.address_line_2.toUpperCase() ? 1 : -1),
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      sorter: (a, b) => (a.city.toUpperCase() > b.city.toUpperCase() ? 1 : -1),
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      sorter: (a, b) => (a.state.toUpperCase() > b.state.toUpperCase() ? 1 : -1),
    },
    {
      title: "Zip",
      dataIndex: "zip",
      key: "zip",
      sorter: (a, b) => (a.zip.toUpperCase() > b.zip.toUpperCase() ? 1 : -1),
    },
    {
      title: "Client Categories",
      dataIndex: "client_category_name",
      key: "client_category_name",
      sorter: (a, b) => (a.client_category_name.toUpperCase() > b.client_category_name.toUpperCase() ? 1 : -1),
    },
    {
      title: "Active?",
      dataIndex: "deleted_at",
      key: "deleted_at",
      render: (value) => (value ? "Deleted" : "Active"),
      sorter: (a, b) => (a.deleted_at > b.deleted_at ? 1 : -1),
    },
  ];
  const client_contacts_columns = [
    {
      title: "Client Name",
      dataIndex: "name",
      key: "name",
      defaultSortOrder: "ascend",
      sorter: (a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1),
    },
    {
      title: "Contact Name",
      dataIndex: "contact_name",
      key: "contact_name",
      sorter: (a, b) => (a.contact_name.toUpperCase() > b.contact_name.toUpperCase() ? 1 : -1),
    },
    {
      title: "Contact Email Address",
      dataIndex: "contact_email",
      key: "contact_email",
      sorter: (a, b) => (a.contact_email.toUpperCase() > b.contact_email.toUpperCase() ? 1 : -1),
    },
  ];
  const no_show_columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (value, row) => <Link to={"/client-details/" + row.client_tag}>{value}</Link>,
      sorter: (a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1),
    },
    {
      title: "Address Line 1",
      dataIndex: "address_line_1",
      key: "address_line_1",
      sorter: (a, b) => (a.address_line_1.toUpperCase() > b.address_line_1.toUpperCase() ? 1 : -1),
    },
    {
      title: "Address Line 2",
      dataIndex: "address_line_2",
      key: "address_line_2",
      sorter: (a, b) => (a.address_line_2.toUpperCase() > b.address_line_2.toUpperCase() ? 1 : -1),
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      sorter: (a, b) => (a.city.toUpperCase() > b.city.toUpperCase() ? 1 : -1),
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      sorter: (a, b) => (a.state.toUpperCase() > b.state.toUpperCase() ? 1 : -1),
    },
    {
      title: "Zip",
      dataIndex: "zip",
      key: "zip",
      sorter: (a, b) => (a.zip.toUpperCase() > b.zip.toUpperCase() ? 1 : -1),
    },
    {
      title: "Emails",
      dataIndex: "all_emails",
      key: "all_emails",
      render: (value) => <Input.TextArea value={value} />,
      sorter: (a, b) => (a.all_emails.toUpperCase() > b.all_emails.toUpperCase() ? 1 : -1),
    },
  ];
  const client_growth_columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (value, row) => <Link to={"/client-details/" + row.client_tag}>{value}</Link>,
      sorter: (a, b) => (a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1),
    },
    {
      title: "Client Categories",
      dataIndex: "client_category_name",
      key: "client_category_name",
      sorter: (a, b) => (a.client_category_name.toUpperCase() > b.client_category_name.toUpperCase() ? 1 : -1),
    },
    {
      title: "Date Added",
      dataIndex: "created_at",
      key: "created_at",
      render: (value) => props.MakeDateTimeReadable(value),
    },
  ];
  const company_setting_tabs = [
    {
      label: "Full Client List",
      key: 0,
      children: (
        <>
          <Row gutter={[16, 16]}>
            <Col span={18}></Col>
            <Col span={6}>
              <Input
                value={fullClientsListSearchTerm}
                placeholder="Search..."
                onChange={(e) => {
                  setFullClientsListSearchTerm(e.target.value);
                }}
              />
            </Col>

            <Col span={24} ref={printableRef1}>
              <Table
                dataSource={filteredFullClientsList}
                columns={full_client_list_columns}
                pagination={{
                  pageSizeOptions: [25, 50, 100, 1000],
                  pageSize: table1PageSize,
                  showSizeChanger: true,
                  defaultPageSize: 25,
                  onShowSizeChange: (current, size) => {
                    setTable1PageSize(size);
                  },
                }}
              />
            </Col>
            <Col span={24} className="text-right no-print">
              <Space>
                <CSVLink filename="TableContent.csv" size="small" data={filteredFullClientsList}>
                  <Button type="primary" size="small">
                    <FontAwesomeIcon icon={faFileDownload} className="mr-2" /> Download CSV File
                  </Button>
                </CSVLink>
                <ReactToPrint
                  trigger={() => (
                    <Button size="small">
                      <FontAwesomeIcon icon={faPrint} className="mr-2" /> Print Table
                    </Button>
                  )}
                  content={() => printableRef1.current}
                />
              </Space>
            </Col>
          </Row>
        </>
      ),
    },
    {
      label: "Client Contacts List",
      key: 1,
      children: (
        <>
          <Row gutter={[16, 16]}>
            <Col span={18}></Col>
            <Col span={6}>
              <Input
                value={fullClientContactsListSearchTerm}
                placeholder="Search..."
                onChange={(e) => {
                  setFullClientContactsListSearchTerm(e.target.value);
                }}
              />
            </Col>

            <Col span={24} ref={printableRef1}>
              <Table
                dataSource={filteredFullClientContactsList}
                columns={client_contacts_columns}
                pagination={{
                  pageSizeOptions: [25, 50, 100, 1000],
                  pageSize: table1PageSize,
                  showSizeChanger: true,
                  defaultPageSize: 25,
                  onShowSizeChange: (current, size) => {
                    setTable1PageSize(size);
                  },
                }}
              />
            </Col>
            <Col span={24} className="text-right no-print">
              <Space>
                <CSVLink filename="TableContent.csv" size="small" data={filteredFullClientContactsList}>
                  <Button type="primary" size="small">
                    <FontAwesomeIcon icon={faFileDownload} className="mr-2" /> Download CSV File
                  </Button>
                </CSVLink>
                <ReactToPrint
                  trigger={() => (
                    <Button size="small">
                      <FontAwesomeIcon icon={faPrint} className="mr-2" /> Print Table
                    </Button>
                  )}
                  content={() => printableRef1.current}
                />
              </Space>
            </Col>
          </Row>
        </>
      ),
    },
    {
      label: "Client No-Show Report",
      key: 2,
      children: (
        <Row gutter={[16, 16]}>
          <Col span={6}></Col>
          <Col span={5}>
            <label className="col-form-label-sm">Job Item</label>
            <Select options={items} onChange={(e) => setNoShowJob(e)} />
          </Col>
          <Col span={5}>
            <label className="col-form-label-sm">Previously had a Job During...</label>
            <DatePicker.RangePicker
              allowClear={false}
              className="w-100"
              value={noShowStartDates}
              presets={props.default_rangepicker_presets}
              onCalendarChange={(dates) => setNoShowStartDates(dates)}
              format="M/YYYY"
            />
          </Col>
          <Col span={5}>
            <label className="col-form-label-sm">Did not have a Job During...</label>
            <DatePicker.RangePicker
              allowClear={false}
              className="w-100"
              value={noShowEndDates}
              presets={props.default_rangepicker_presets}
              onCalendarChange={(dates) => setNoShowEndDates(dates)}
              format="M/YYYY"
            />
          </Col>
          <Col span={3} className="text-right">
            <label className="col-form-label-sm w-100">&nbsp;</label>
            <Button
              type="primary"
              className="w-100"
              onClick={() => {
                GetNoShows();
              }}
            >
              Search
            </Button>
          </Col>

          <Col span={24} ref={printableRef2}>
            <Table
              dataSource={noShowClients}
              columns={no_show_columns}
              pagination={{
                pageSizeOptions: [25, 50, 100, 1000],
                pageSize: table1PageSize,
                showSizeChanger: true,
                defaultPageSize: 25,
                onShowSizeChange: (current, size) => {
                  setTable1PageSize(size);
                },
              }}
            />
          </Col>
          <Col span={24} className="text-right">
            <Space>
              <CSVLink filename="NoShowClients.csv" data={noShowClients}>
                <Button type="primary" size="small">
                  <FontAwesomeIcon icon={faFileDownload} className="mr-2" /> Download CSV File
                </Button>
              </CSVLink>
              <ReactToPrint
                trigger={() => (
                  <Button size="small">
                    <FontAwesomeIcon icon={faPrint} className="mr-2" /> Print Table
                  </Button>
                )}
                content={() => printableRef2.current}
              />
            </Space>
          </Col>
        </Row>
      ),
    },
    {
      label: "Client Growth Report",
      key: 3,
      children: (
        <Row gutter={[16, 16]}>
          <Col span={6}></Col>
          <Col span={5}></Col>
          <Col span={5}>
            <label className="col-form-label-sm">Date Range *</label>
            <DatePicker.RangePicker
              className="w-100"
              allowClear={false}
              picker="month"
              value={clientGrowthDates}
              presets={props.default_rangepicker_presets}
              onCalendarChange={(dates) => setClientGrowthDates(dates)}
              format="M/YYYY"
            />
          </Col>
          <Col span={5}>
            <label className="col-form-label-sm">Client Category</label>
            <Select
              options={clientCategories}
              onChange={(e) => {
                setClientGrowthCategories(e);
              }}
              isMulti
            />
          </Col>
          <Col span={3} className="text-right">
            <label className="col-form-label-sm w-100">&nbsp;</label>
            <Button
              type="primary"
              className="w-100"
              onClick={() => {
                GetClientGrowth();
              }}
            >
              Search
            </Button>
          </Col>
          <Col span={24}>
            {clientGrowthData && clientGrowthData.length > 0 ? (
              <Bar
                options={{
                  responsive: true,
                  plugins: {
                    legend: {
                      position: "top",
                    },
                    title: {
                      display: true,
                      text: "Year Clients Added",
                    },
                  },
                }}
                data={clientGrowthChartData}
              />
            ) : null}
          </Col>
          <Col span={24} ref={printableRef3}>
            <Table
              dataSource={clientGrowthData}
              columns={client_growth_columns}
              pagination={{
                pageSizeOptions: [25, 50, 100, 1000],
                pageSize: table1PageSize,
                showSizeChanger: true,
                defaultPageSize: 25,
                onShowSizeChange: (current, size) => {
                  setTable1PageSize(size);
                },
              }}
            />
          </Col>
          <Col span={24} className="text-right">
            <Space>
              <CSVLink filename="ClientGrowthData.csv" data={clientGrowthData}>
                <Button type="primary" size="small">
                  <FontAwesomeIcon icon={faFileDownload} className="mr-2" /> Download CSV File
                </Button>
              </CSVLink>
              <ReactToPrint
                trigger={() => (
                  <Button size="small">
                    <FontAwesomeIcon icon={faPrint} className="mr-2" /> Print Table
                  </Button>
                )}
                content={() => printableRef2.current}
              />
            </Space>
          </Col>
        </Row>
      ),
    },
    {
      label: "Mailing Labels",
      key: 4,
      children: (
        <>
          <Row gutter={[16, 16]}>
            <Col span={6}>
              <label className="col-form-label-sm w-100">&nbsp;</label>
            </Col>
            <Col span={5}></Col>
            <Col span={5}></Col>
            <Col span={5}>
              <label className="col-form-label-sm">Mailing Label Format</label>
              <Select
                options={[
                  { label: "Avery 5160", value: "avery-5160" },
                  { label: "Avery 8463", value: "avery-8463" },
                ]}
                onChange={(e) => {
                  setMailingLabelType(e);
                }}
              />
            </Col>
            <Col span={3} className="text-right">
              <label className="col-form-label-sm w-100">&nbsp;</label>
              <ReactToPrint
                trigger={() => {
                  // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                  // to the root node of the returned component as it will be overwritten.
                  return (
                    <Space>
                      <Button
                        type="primary"
                        onClick={() => {
                          if (!mailingLabelType?.value) return props.MakeNotification("warning", "Please select a mailing label form.");
                        }}
                      >
                        Print Labels
                      </Button>
                    </Space>
                  );
                }}
                content={() => printTarget?.current}
              />
            </Col>

            <Col span={24}>
              <Table
                rowSelection={{
                  type: "checkbox",
                  ...rowSelection,
                }}
                dataSource={filteredFullClientsList}
                columns={full_client_list_columns}
                pagination={{
                  pageSizeOptions: [25, 50, 100, 1000],
                  pageSize: table1PageSize,
                  showSizeChanger: true,
                  defaultPageSize: 25,
                  onShowSizeChange: (current, size) => {
                    setTable1PageSize(size);
                  },
                }}
              />
            </Col>
          </Row>
          <div className="modal fade" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document" style={{ maxWidth: "1000px" }}>
              <div className="modal-content">
                <div className="mailing-label-body" ref={printTarget}>
                  {mailingLabelClients.map((f, i) => {
                    if (i % 30 === 0 && i !== 0) {
                      return (
                        <span>
                          <div className="mailing-label-page-break"></div>
                          <div className="page-break-tail"></div>
                          <div className="label-avery-5160">
                            {f.name}
                            <br />
                            {f.line_1}
                            <br />
                            {f.line_2}
                          </div>
                        </span>
                      );
                    }
                    return (
                      <div className="label-avery-5160">
                        {f.name}
                        <br />
                        {f.line_1}
                        <br />
                        {f.line_2}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];
  return (
    <main className="content">
      <div className="container-fluid">
        <div className="header">
          <h1 className="header-title">Client Reports</h1>
        </div>
        <Card>
          <Tabs tabPosition="left" size="large" items={company_setting_tabs} />
        </Card>
      </div>
    </main>
  );
}

let colors = [
  "rgba(90, 255, 21, .3)",
  "rgba(170, 255, 229, .4)",
  "rgba(32, 42, 37, .3)",
  "rgba(127, 7, 153, .3)",
  "rgba(250, 201, 184, .4)",
  "rgba(255, 74, 28, .3)",
  "rgba(125, 69, 27, .3)",
  "rgba(34, 116, 165, .3)",
  "rgba(200, 62, 77, .3)",
  "rgba(117, 13, 55, .3)",
];
let colors_border = [
  "rgba(90, 255, 21, 1)",
  "rgba(170, 255, 229, 1)",
  "rgba(32, 42, 37, 1)",
  "rgba(127, 7, 153, 1)",
  "rgba(250, 201, 184, 1)",
  "rgba(255, 74, 28, 1)",
  "rgba(125, 69, 27, 1)",
  "rgba(34, 116, 165, 1)",
  "rgba(200, 62, 77, 1)",
  "rgba(117, 13, 55, 1)",
];

export default ClientReports;
